module.exports = __webpack_public_path__ + "media/images/review_ribbon-9c4d3fea9036798d6518e4fcad2fc22b.svg";